// extracted by mini-css-extract-plugin
export default {"content":"style_content__1g2LV","itemName":"style_itemName__Gczhw"};